import { FC, SVGProps } from 'react';

export const MinusIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M13.4387 7.375H2.625C2.27982 7.375 2 7.65482 2 8C2 8.34518 2.27982 8.625 2.625 8.625L13.4387 8.625C13.7839 8.625 14.0637 8.34518 14.0637 8C14.0637 7.65482 13.7839 7.375 13.4387 7.375Z"
			fill="currentColor"
		/>
	</svg>
);
